import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-dark-200 hover:border-athletic-300 hover:shadow-card-hover transition-all duration-300"
    >
      <div className="aspect-square bg-dark-50 relative overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
        {product.badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 text-athletic-800 text-[10px] font-semibold uppercase tracking-wider bg-athletic-100 rounded-full">{product.badge}</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-dark-400 mb-1.5">{product.categorySlug?.replace(/-/g, ' ')}</p>
        <h3 className="font-display text-lg font-semibold text-dark-900 mb-2 group-hover:text-athletic-700 transition-colors line-clamp-2 leading-snug">{product.name}</h3>
        <p className="text-sm text-dark-500 line-clamp-2 mb-4 flex-grow">{product.description}</p>
        <div className="flex items-center justify-between gap-2 mt-auto">
          <span className="text-xl font-semibold text-dark-900">${product.price.toFixed(2)}</span>
          <button onClick={handleAddToCart} aria-label="Add to cart" className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-athletic-600 text-white text-sm font-semibold hover:bg-athletic-700 transition-colors">
            <Plus className="w-4 h-4" /> Add
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
